<app-header></app-header>

<ion-content scrollbar class="ion-content-padding-top-0">
  <app-list-header
    [absoluteFilterButton]="true"
    (toggleFilter)="onToggleFilter()"
  >
    <ng-container top>
      <app-search-bar
        #searchBar
        [permissionEdit]="rentalAddRole"
        addLink="./add"
        buttonAddLabel="{{ 'ADD' | translate}}"
        (searchEvent)="onChangeSearch()"
      >
      </app-search-bar>
    </ng-container>
    <ng-container bottom>
      <app-select-dropdown
        *ngIf="!p.renderMobile"
        class="rental__dropdown"
        (changeValueEvent)="onStatusChanged($event)"
        [data]="rentalStatusArray"
        placeholder="RENTAL.STATUS.STATUS"
      >
      </app-select-dropdown>
    </ng-container>
  </app-list-header>

  <ion-fab
    *ngIf="p.renderMobile && rentalAddRole"
    vertical="bottom"
    horizontal="end"
    slot="fixed"
  >
    <ion-fab-button routerLink="./add">
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab>
  <app-pagination-client-side
    [ngClass]="{'height-0': showLoader}"
    [columns]="columnsDefinition"
    [componentRef]="componentRef"
    (rowsLoaderReady)="rowsLoaderServiceReady($event)"
    [options]="options"
    (actionRequest)="handleActionRequest($event)"
    (refreshRequest)="getItems()"
  >
  </app-pagination-client-side>
  <ng-container *ngIf="showLoader">
    <app-loading-sti></app-loading-sti>
  </ng-container>
</ion-content>
